import React, { memo, useState } from 'react';
import Link from 'components/Link';
import PropTypes from 'prop-types';
import ImageV2 from 'components_v2/common/ImageV2';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import SocialSharingWeb from 'routes/articleshow_v2/components/desktop/SocialSharingWeb';
import LiveNowIcon from 'components_v2/common/InitNewscardComponents/LiveNowIcon';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import PopupOverlay from 'components_v2/common/PopupOverlay/PopupOverlay';
import Video from 'components/Video/Video';
import s from './NewStoryCard.scss';
import { IMAGE_URL } from '../../../constants';
import LeadLiveIcon from '../../common/LeadLiveIcon/LeadLiveIcon';

function NewStoryCard({
  title,
  msid,
  des,
  isLarge,
  wu,
  tn,
  target,
  imagesize,
  imageUrl,
  // isWapView,
  sectionName,
  index,
  // lazyloadImg,
  shouldNotlazyloadImage,
  ga4Type,
  ga4Label,
  ga4Category,
  gaIndex,
  cardType,
  isBigHeading,
  isVideoActive,
  syn,
  iconClass,
  criticRating,
  cmstype,
  videoTime,
  createdTime,
  forceTargetBlank,
  createdTime2,
  fromToiPrint,
  synStyle,
  width = 600,
  imageHeight,
  slikeId,
  // certificate,
  movieCardData,
  userRating,
  userCount,
  onClick,
  subTitle,
  usePosterImage,
  hideContent,
  showIIcon,
  showPlayIconAlso,
  showPopup,
  onCriticRatingClick,
  onUserRatingClick,
  onVideoIconClick,
  imagePlaceHolderSrc,
  doNotStopClickPropagation,
  addTitleAsHeading,
}) {
  if (!cmstype && tn) {
    const TN_CMSTYPE_MAPPING = {
      photostory: 'PHOTOGALLERYSLIDESHOWSECTION',
      video: 'MEDIAVIDEO',
      liveblog: 'LIVEBLOG',
    };
    const TN_ICONCLASS_MAPPING = {
      photostory: 'photoIcon',
      video: 'videoshowIcon',
      // liveblog: 'liveIconWrapper',
    };
    cmstype = TN_CMSTYPE_MAPPING[tn] || '';
    if (!iconClass) {
      iconClass = TN_ICONCLASS_MAPPING[tn] || '';
    }
  }
  const ImageElement = ImageV2;
  const [showSharing, setShowSharing] = useState(false);
  const [hoveredSlikeId, sethoveredSlikeId] = useState(false);
  const [showDes, setShowDes] = useState(false);
  const [showBannerPopup, setShowBannerPopup] = useState(false);
  const [bannerPopup, setBannerPopup] = useState(null);
  const checkHtml = /(<([^>]+)>)/i;
  const htmlStatus = title ? checkHtml.test(title) : '';
  let resizemode = 4;
  let height;
  let iconClass2;
  if (
    cardType !== 'card_9' &&
    (cmstype === 'PHOTOGALLERYSLIDESHOWSECTION' ||
      cmstype === 'MOVIEREVIEW' ||
      tn === 'movie reviews' ||
      tn === 'movie-review' ||
      usePosterImage)
  ) {
    resizemode = 75;
    height = imageHeight || 400;
  } else if (cardType === 'card_9') {
    iconClass2 = s.vsIcon;
  }

  const handleShowDesInCard = () => {
    setShowDes(!showDes);
  };

  const handleClosePopup = () => {
    if (document?.querySelector) {
      document.querySelector('body').classList.remove('overflowhidden');
    }
    setShowBannerPopup(false);
  };

  const handleBannerClick = banner => {
    if (document?.querySelector) {
      document.querySelector('body').classList.add('overflowhidden');
    }
    setShowBannerPopup(true);
    setBannerPopup(banner);
  };
  const updateplayerConfig = { skipReco: true };

  const onError = e => {
    e.target.onerror = null;
    e.target.src =
      imagePlaceHolderSrc || 'https://static.toiimg.com/photo/34824568.cms';
  };

  const renderPopupImage = () => (
    <PopupOverlay
      position="center"
      closeCallback={handleClosePopup}
      show={showBannerPopup}
      blackOverlayEnabled
      fixWidth={!!bannerPopup.slikeId}
    >
      {bannerPopup.slikeId ? (
        <Video
          msid={bannerPopup.id}
          autoplay
          slikeId={bannerPopup.slikeId}
          playerType={bannerPopup.playerType}
          videoClassName="popup_video_wrapper"
          // slikeNextVideoAutoPlayed={this.state.slikeNextVideoAutoPlayed}
          //store={this.context.store}
          allowDim={false}
          source="USNHP_MainVideoWidget"
          updateplayerConfig={updateplayerConfig}
          // isUserPrime={this.props.isUserPrime}
          // outsideEventListener={(...args) => {
          //   this.videoEventListener(...args);
          // }}
        />
      ) : (
        // <video
        //   src={`https://tvid.in/r/vp.${bannerPopup.slikeId}.mp4`}
        //   width="100%"
        //   height="100%"
        //   autoPlay
        //   controls
        //   loop
        //   playsInline
        //   muted={false}
        //   poster={`${IMAGE_URL}${bannerPopup.id}.cms`}
        // >
        //   <track kind="captions" src="" label={bannerPopup.title} />
        // </video>
        <div className={s.bannerPopupImage}>
          <ImageElement
            msid={bannerPopup.id}
            resizemode={4}
            imgsize={bannerPopup.imagesize}
            height="620"
            // src={`${IMAGE_URL}${bannerPopup.id}.cms`}
            // width="620"
            alt={bannerPopup.hl}
            title={bannerPopup.title || ''}
            placeHolderSrc={imagePlaceHolderSrc || `${IMAGE_URL}87458172.cms`}
            onError={imagePlaceHolderSrc ? onError : undefined}
          />
        </div>
      )}
    </PopupOverlay>
  );

  const TitleTag = addTitleAsHeading ? 'h3' : 'p';

  const renderContent = () => (
    <>
      {cardType !== 'card_10' &&
        cardType !== 'card_11' &&
        cardType !== 'card_22' &&
        cardType !== 'card_14' &&
        cardType !== 'card_11_2' && (
          <div className={s.imgWrap}>
            {cardType !== 'card_11_1' && (
              <div className={s.storyImg}>
                <ImageElement
                  key={msid}
                  width={width || 600}
                  height={height}
                  msid={msid}
                  imgsize={imagesize}
                  placeHolderSrc={
                    imagePlaceHolderSrc || `${IMAGE_URL}87458172.cms`
                  }
                  onError={imagePlaceHolderSrc ? onError : undefined}
                  alt=""
                  lazyload={!shouldNotlazyloadImage}
                  offsetVertical={300}
                  resizemode={resizemode}
                  hoveredSlikeId={hoveredSlikeId}
                  gaIndex={gaIndex}
                  hoveredSlikeIndex={gaIndex}
                  slikeId={slikeId}
                  src={imageUrl}
                />
              </div>
            )}
            {cardType !== 'card_2' && (
              <span
                className={`${s[iconClass]} ${iconClass2}`}
                onClick={e => {
                  if (typeof onVideoIconClick === 'function') {
                    e.preventDefault();
                    e.stopPropagation();
                    onVideoIconClick();
                  }
                }}
              >
                <i />
                {videoTime && <span> {videoTime} </span>}
              </span>
            )}
            {showPlayIconAlso && (
              <span className={`${s.videoIcon}`}>
                <i />
              </span>
            )}

            {/* We need to remove this and make the common one */}
            {cmstype &&
              cmstype === 'LIVEBLOG' && (
                <span className={s.liveIconWrapper}>
                  <LeadLiveIcon />
                </span>
              )}
            {criticRating &&
              cardType !== 'card_27' &&
              cardType !== 'card_27_1' &&
              cardType !== 'card_29' && (
                <div
                  className={`${s.ratingWrap} ${
                    cardType === 'card_2' ? s.topPos : ''
                  }`}
                >
                  <div className={s.ratingPosition}>
                    <div className={s.ratings}>
                      <p className={s.ratingsGiven}>
                        {criticRating} <span className={s.starIcon} />
                      </p>
                      <p className={s.ratingsBy}>Critics</p>
                    </div>
                  </div>
                </div>
              )}

            {showIIcon && (
              <span
                className={`${s[iconClass]} ${s.infoIcon}`}
                onClick={handleShowDesInCard}
              >
                i
              </span>
            )}

            {des && (
              <p
                className={`${s.infoTextOverlay} ${showDes ? s.show : ''}`}
                dangerouslySetInnerHTML={{ __html: des }}
              />
            )}
          </div>
        )}
      {!hideContent && (
        <div className={`${s.scContentWrap} bg_color`}>
          {cardType === 'card_2' && (
            <span className={`${s[iconClass]} ${iconClass2}`}>
              <i />
              {videoTime && <span> {videoTime} </span>}
            </span>
          )}
          {cardType === 'card_8' &&
            cmstype &&
            cmstype === 'LIVEBLOG' && (
              <div className={s.liveBlinker}>
                <LiveNowIcon text="LIVE NOW" />
              </div>
            )}

          <>
            {htmlStatus ? (
              <TitleTag
                className={`${s.cardHeading} style_change`}
                dangerouslySetInnerHTML={{
                  __html: `${cardType === 'card_22' &&
                    `<span class="videoplayIcon">
                    <i></i>
                  </span>`} ${title}`,
                }}
              />
            ) : (
              <TitleTag className={`${s.cardHeading} style_change`}>
                {cardType === 'card_22' && (
                  <span className="videoplayIcon">
                    <i />
                  </span>
                )}{' '}
                {title}
              </TitleTag>
            )}
            {subTitle && <p className={s.cardText}>{subTitle}</p>}
          </>
          {movieCardData && (
            <div className={s.geners}>
              {Object.values(movieCardData).map((value, moviePropertyIndex) => {
                if (!(value && (value.label || value.component))) return null; // Skip empty values
                if (value.link) {
                  return (
                    <span key={moviePropertyIndex}>
                      <Link to={value.link}>{value.label}</Link>
                    </span>
                  );
                }
                if (value.component) {
                  return (
                    <span key={moviePropertyIndex}>{value.component}</span>
                  );
                }
                return <span key={moviePropertyIndex}>{value.label}</span>;
              })}
            </div>
          )}
          {syn &&
            cardType === 'card_27_1' && (
              <p className={s.cardText} style={synStyle}>
                {syn}
              </p>
            )}
          {(cardType === 'card_27' || cardType === 'card_27_1') && (
            <div className={s.innerWrap}>
              <div className={`${s.ratingWrap} ${s.ratingReview}`}>
                {criticRating && (
                  <div
                    className={s.ratings}
                    onClick={e => {
                      if (typeof onCriticRatingClick === 'function') {
                        e.preventDefault();
                        e.stopPropagation();
                        onCriticRatingClick();
                      }
                    }}
                  >
                    <p className={s.ratingsGiven}>
                      {criticRating} <span className={s.starIcon} />
                    </p>
                    <p className={s.ratingsBy}>Critic&apos;s Rating</p>
                  </div>
                )}
                {userRating && (
                  <div
                    className={s.ratings}
                    onClick={e => {
                      if (typeof onUserRatingClick === 'function') {
                        e.preventDefault();
                        e.stopPropagation();
                        onUserRatingClick();
                      }
                    }}
                  >
                    <p className={s.ratingsGiven}>
                      {userRating} <span className={s.starIcon} />
                    </p>
                    <p className={s.ratingsBy}>
                      Users&apos; Rating {userCount ? `(${userCount})` : ''}
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
          {cardType === 'card_29' &&
            criticRating && (
              <div className={`${s.ratingWrap} ${s.ratingReview}`}>
                <div className={s.ratings}>
                  <p className={s.ratingsBy}>Critic&apos;s Rating: </p>
                  <p className={s.ratingsGiven}>
                    {criticRating} <span className={s.starIcon} />
                  </p>
                </div>
              </div>
            )}
          {createdTime2 && <p className={s.createdTime}>{createdTime2}</p>}
          {syn &&
            cardType !== 'card_27_1' && (
              <p className={s.cardText} style={synStyle}>
                {syn}
              </p>
            )}
          {sectionName && <div className={s.catText}>{sectionName}</div>}
          {createdTime && <span className={s.createdTime}> {createdTime}</span>}
          {fromToiPrint && (
            <div className={s.fromToiWrap}>
              <span>From TOI Print Edition</span>
              {/* Share component will come here */}
              <div
                className={`${s.timelineshare} icon_share_wrap`}
                // onClick={isWapView && socialWidgetToggle}
                onMouseEnter={() => setShowSharing(!showSharing)}
                onMouseLeave={() => setShowSharing(!showSharing)}
              >
                <div className={s.shareIconWrap}>
                  <span className={s.shareIcon} />
                  {showSharing && (
                    <div className={`${s.shareWrap}`}>
                      <ErrorBoundary>
                        <SocialSharingWeb
                          title={title}
                          textRequired={false}
                          url={wu || ''}
                          disableShortUrl
                          linkeDin
                          via="@timesofindia"
                          // gaAction="Click"
                          // gaCategory="Election_Widget_Homepage"
                          topsticky
                          defaultEmailView
                        />
                      </ErrorBoundary>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );

  return wu ? (
    <Link
      // eslint-disable-next-line no-script-url
      to={wu || 'javascript:void(0)'}
      target={!target ? '_blank' : target}
      forceTargetBlank={forceTargetBlank}
      className={`border_color ${s.storyCard} ${isLarge ? s.isLarge : ''} ${
        cardType ? s[cardType] : ''
      } ${isBigHeading ? s.bigHeading : ''} ${!wu ? s.noLink : ''} ${
        isVideoActive ? s.videoActive : ''
      } `}
      onMouseEnter={() => sethoveredSlikeId(slikeId)}
      onMouseLeave={() => sethoveredSlikeId(false)}
      onClick={e => {
        if (typeof onClick === 'function') {
          if (!doNotStopClickPropagation) {
            e.preventDefault();
            e.stopPropagation();
          }
          onClick();
          return false;
        }
        if (ga4Type) {
          analyticsWrapper('ga4', {
            event: 'user_click',
            type: `${ga4Type}`,
            category: ga4Category || 'story_click',
            story_no: `${index?.gaindex || gaIndex}`,
            msid,
            label: ga4Label,
          });
        }
        try {
          if (showIIcon || e.target.dataset.ga.includes('share')) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
        } catch (error) {
          //
        }

        return true;
      }}
    >
      {renderContent()}
    </Link>
  ) : (
    <>
      {bannerPopup &&
        showBannerPopup &&
        bannerPopup?.imageid &&
        renderPopupImage()}
      <div
        className={`border_color ${s.normalStoryCard} ${s.storyCard} ${
          isLarge ? s.isLarge : ''
        } ${cardType ? s[cardType] : ''} ${isBigHeading ? s.bigHeading : ''} ${
          isVideoActive ? s.videoActive : ''
        }`}
        onMouseEnter={() => sethoveredSlikeId(slikeId)}
        onMouseLeave={() => sethoveredSlikeId(false)}
        onClick={e => {
          if (typeof onClick === 'function') {
            e.preventDefault();
            e.stopPropagation();
            onClick();
            return false;
          }
          if (ga4Type) {
            analyticsWrapper('ga4', {
              event: 'user_click',
              type: `${ga4Type}`,
              category: ga4Category || 'story_click',
              story_no: `${index?.gaindex || gaIndex}`,
              msid,
              label: ga4Label,
            });
          }
          if (showPopup) {
            e.preventDefault();
            const data = {
              imageid: msid,
              slikeId,
              id: msid,
              resizemode,
            };
            handleBannerClick(data);
          }
          try {
            if (showIIcon || e.target.dataset.ga.includes('share')) {
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
          } catch (error) {
            //
          }

          return true;
        }}
      >
        {renderContent()}
      </div>
    </>
  );
}
NewStoryCard.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  isLable: PropTypes.bool,
  isLarge: PropTypes.string,
  ga4Type: PropTypes.string,
  ga4Label: PropTypes.string,
  gaIndex: PropTypes.number,
  cardType: PropTypes.string,
  shouldNotlazyloadImage: PropTypes.bool,
  target: PropTypes.string,
};

NewStoryCard.defaultProps = {
  isLable: false,
  isLarge: '',
  ga4Type: '',
  ga4Label: '',
  gaIndex: '',
  cardType: '',
  shouldNotlazyloadImage: false,
  target: '',
};

export default memo(NewStoryCard);
